import {gfmAutolinkLiteralFromMarkdown} from "mdast-util-gfm-autolink-literal";
import {gfmStrikethroughFromMarkdown} from "mdast-util-gfm-strikethrough";
import {gfmAutolinkLiteral} from "micromark-extension-gfm-autolink-literal";
import {gfmStrikethrough} from "micromark-extension-gfm-strikethrough";
import {combineExtensions} from "micromark-util-combine-extensions";
import type {Processor} from "unified";

export default function parialGfmMarkdownPlugin(this: Processor) {
  const data = this.data();
  (data.micromarkExtensions ??= []).push(
    combineExtensions([gfmAutolinkLiteral(), gfmStrikethrough()])
  );

  (data.fromMarkdownExtensions ??= []).push(
    gfmAutolinkLiteralFromMarkdown(),
    gfmStrikethroughFromMarkdown()
  );
}
